import type { Facility } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import {
	FACILITIES_CLEANING_SERVICE,
	FACILITIES_COMMON_AREA,
	FACILITIES_FOOD,
	FACILITIES_SPA,
	FACILITIES_TRANSPORT,
} from "@/components/features/items/edit/_shared/constants/amenities-and-facilities";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { CheckboxGroupWithAccordionField } from "@/components/ui/form/fields/check-box-field/check-box-group-with-accordion";

import { useFacilitiesOfHotelPolicy } from "./hooks";

import type { CheckedState } from "@radix-ui/react-checkbox";

export const QuestionHotelPolicyFacilities = () => {
	const { facilities, updateFacilities } = useFacilitiesOfHotelPolicy();

	const commonAreaOptions = FACILITIES_COMMON_AREA.map((item) => {
		return {
			id: "facilities_common_area" + item.key,
			label: item.key,
			value: item.value,
		} satisfies FormOptionType;
	});

	const commonAreaLabel = "共用エリア";

	const handleFacilitiesInput = (checked: CheckedState, item: FormOptionType) => {
		if (checked === "indeterminate") return;

		updateFacilities(checked, item.value as Facility);
	};

	const foodOptions = FACILITIES_FOOD.map((item) => {
		return {
			id: "facilities_food_" + item.key,
			label: item.key,
			value: item.value,
		} satisfies FormOptionType;
	});
	const foodLabel = "飲食施設・設備";

	const spaOptions = FACILITIES_SPA.map((item) => {
		return {
			id: "facilities_spa_" + item.key,
			label: item.key,
			value: item.value,
		} satisfies FormOptionType;
	});
	const spaLabel = "プール・スパ・温泉";

	const transportOptions = FACILITIES_TRANSPORT.map((item) => {
		return {
			id: "facilities_transport_" + item.key,
			label: item.key,
			value: item.value,
		} satisfies FormOptionType;
	});
	const transportLabel = "交通・シャトル";

	const cleaningServiceOptions = FACILITIES_CLEANING_SERVICE.map((item) => {
		return {
			id: "facilities_cleaning_service_" + item.key,
			label: item.key,
			value: item.value,
		} satisfies FormOptionType;
	});
	const cleaningServiceLabel = "クリーニングサービス";

	return (
		<div>
			<FeatureIslandCategoryQuestionForMain
				required={false}
				isEdited={facilities.isEdited}
				hasError={facilities.hasError}
				title={"施設の設備・サービス"}
				inputChildren={
					<div className="flex flex-col gap-y-8">
						<div className="flex flex-col gap-y-4">
							<CheckboxGroupWithAccordionField
								accordionLabel={commonAreaLabel}
								checkBoxGroupProps={{
									value: facilities.value.map((item) => item.value),
									options: commonAreaOptions,
									handleCheckedChange: handleFacilitiesInput,
									gridCols: 2,
								}}
							/>
							<CheckboxGroupWithAccordionField
								accordionLabel={foodLabel}
								checkBoxGroupProps={{
									value: facilities.value.map((item) => item.value),
									options: foodOptions,
									handleCheckedChange: handleFacilitiesInput,
									gridCols: 2,
								}}
							/>
							<CheckboxGroupWithAccordionField
								accordionLabel={spaLabel}
								checkBoxGroupProps={{
									value: facilities.value.map((item) => item.value),
									options: spaOptions,
									handleCheckedChange: handleFacilitiesInput,
									gridCols: 2,
								}}
							/>
							<CheckboxGroupWithAccordionField
								accordionLabel={transportLabel}
								checkBoxGroupProps={{
									value: facilities.value.map((item) => item.value),
									options: transportOptions,
									handleCheckedChange: handleFacilitiesInput,
									gridCols: 2,
								}}
							/>
							<CheckboxGroupWithAccordionField
								accordionLabel={cleaningServiceLabel}
								checkBoxGroupProps={{
									value: facilities.value.map((item) => item.value),
									options: cleaningServiceOptions,
									handleCheckedChange: handleFacilitiesInput,
									gridCols: 2,
								}}
							/>
						</div>
					</div>
				}
			/>
		</div>
	);
};

QuestionHotelPolicyFacilities.displayName = "QuestionHotelPolicyFacilities";
